<template>
    <div>   
        <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
                <a-form-model-item
                        ref="team_name"
                        label="分公司/团队"
                        prop="team_name"
                        :help="formErr.team_name"
                        :validateStatus='!formErr.team_name||formErr.team_name==""?"":"error"'
                >
                    <a-input
                            :maxLength=50
                            v-model="form.team_name"
                            @change="formMaxLength(50,'team_name')"
                            @blur="(e) => {  form.team_name = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="kf_name"
                        label="客服姓名"
                        prop="kf_name"
                        :help="formErr.kf_name"
                        :validateStatus='!formErr.kf_name||formErr.kf_name==""?"":"error"'
                >
                    <a-input
                            :maxLength=50
                            v-model="form.kf_name"
                            @change="formMaxLength(50,'kf_name')"
                            @blur="(e) => {  form.kf_name = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="qq"
                        label="QQ"
                        prop="qq"
                        :help="formErr.qq"
                        :validateStatus='!formErr.qq||formErr.qq==""?"":"error"'
                >
                    <a-input
                            :maxLength=20
                            type="number"
                            v-model="form.qq"
                            @change="formMaxLength(20,'qq')"
                            @blur="(e) => {  form.qq = e.target.value.trim() }"
                    />
                </a-form-model-item>
                 <a-form-model-item
                        ref="status"
                        label="状态"
                        prop="status"
                        :help="formErr.status"
                        :validateStatus='!formErr.status||formErr.status==""?"":"error"'
                >
                 <a-switch checked-children="开启" un-checked-children="关闭" @click="onChange(form.status)"
                    :checked="form.status == 1 ? true : false" />
                </a-form-model-item>
               
            </a-form-model>
            <div class="drawer-btn">
                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">确定</a-button>
                <a-button @click="onClose">取消</a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "filialeForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig,
                form:{
                    team_name:"",
                    kf_name:"",
                    qq:"",
                    status:1

                },
                formErr: {
                    team_name:"",
                    kf_name:"",
                    qq:""
                },
                rules: {
                    team_name: [
                        {required: true, message: "请输入分公司/团队 ",}, 
                        {whitespace: true,message: "请输入分公司/团队 "
                    }, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.team_name)
                        }, trigger: "blur"
                    }],
                    qq: [
                        {required: true, message: "请输入QQ",}, 
                        {whitespace: true,message: "请输入QQ"
                    }, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.qq)
                        }, trigger: "blur"
                    }],
                },
                layout: {
                    labelCol: {span: 6},
                    wrapperCol: {span: 14},
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.administrator.OPEN_EDIT(a).then(res => {
                        let val = res.data.data.info
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.$refs.ruleForm.resetFields();
                this.form={
                    team_name:"",
                    kf_name:"",
                    qq:"",
                    status:1
                }
                this.formErr={
                    team_name:"",
                    kf_name:"",
                    qq:"",
                }
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.administrator.SUBMIT_ADD : url = API.administrator.SUBMIT_EDIT;
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            formMaxLength(len,item){
                this.formErr[item]=''
                if(this.form[item].length>len){
                    this.form[item] = this.form[item].substring(0,len)
                }
            },
            onChange(status){
                if(status == 1){
                    this.form.status = 0
                }else{
                    this.form.status = 1
                }
                 
            }

        },
    }
</script>

<style scoped>

</style>
